import { svg } from './svg.js';
export function element(size) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'svg';
  let x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const elem = svg(type);
  elem.setAttributeNS('', 'x', "".concat(x));
  elem.setAttributeNS('', 'y', "".concat(y));
  elem.setAttributeNS('', 'width', "".concat(size));
  elem.setAttributeNS('', 'height', "".concat(size));
  return elem;
}